import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-chatbot" }
const _hoisted_2 = { class: "container-lil flex flex-col" }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_6 = { class: "card-chatbot" }
const _hoisted_7 = { class: "s2" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "s18 px-7" }
const _hoisted_10 = { class: "flex align-items-center text-grey-800 mb-2 gap-4" }
const _hoisted_11 = {
  key: 0,
  class: "widget-chatbot-tag lil"
}
const _hoisted_12 = { class: "text-grey-600 mb-1" }
const _hoisted_13 = { class: "secondary-font font-semibold text-sm text-grey-400" }
const _hoisted_14 = {
  key: 0,
  class: "text-center my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "page-space-25" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickTags, (tag, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "widget-chatbot-tag mb-3",
            onClick: ($event: any) => (_ctx.startNewChat(tag)),
            style: {"cursor":"pointer"}
          }, _toDisplayString(tag.label), 9, _hoisted_4))
        }), 128))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "secondary-font mt-8" }, "Vos conversations", -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Chargement des conversations..."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedConversations, (conversation) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: conversation.id,
                to: `/front/aide/live-tchat/${conversation.id}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("img", {
                        src: conversation.agentAvatar,
                        width: "100%",
                        class: "rounded-100",
                        alt: "Agent"
                      }, null, 8, _hoisted_8)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h4", _hoisted_10, [
                        _createTextVNode(_toDisplayString(conversation.agentName) + " ", 1),
                        (conversation.tag)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(conversation.tag), 1))
                          : _createCommentVNode("", true),
                        (conversation.status)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(['tag-state', conversation.statusClass, 'stroke'])
                            }, _toDisplayString(conversation.status), 3))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(conversation.lastMessage), 1),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.formatTimeAgo(conversation.lastMessageTime)), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128)),
            (_ctx.formattedConversations.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("p", null, "Aucune conversation pour le moment.", -1),
                  _createElementVNode("p", { class: "text-grey-600 mt-2" }, "Utilisez les tags ci-dessus pour démarrer une nouvelle conversation.", -1)
                ]))]))
              : _createCommentVNode("", true)
          ], 64)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
    ])
  ]))
}